import React from "react";
import PropTypes from "prop-types";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/summary/TextSummary.scss';

const TextSummary = ({ summary }) => {
  if (!summary) {
    return null;
  }

  return (
    <div className="csw-text-summary">
      <div className="h2 h-trim" role="heading" aria-level="1">
        {summary.text}
      </div>
      <div className="csw-text-summary-detail">{summary.body}</div>
    </div>
  );
};

TextSummary.propTypes /* remove-proptypes */ = {
  summary: PropTypes.object.isRequired,
};

export default TextSummary;
